module.exports = __webpack_public_path__ + "static/media/icono-modificar.48252c1a.svg";